var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isStake === true ? _c('div', {
    staticClass: "type"
  }, [_c('fa', {
    attrs: {
      "icon": "coins"
    }
  }), _vm._v(" UTXO was in Staking Set ")], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }